import { REPORT } from '@consts/reports';
import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { count, countUnique, sum } from '@utils/summaries';
import { getMonthInfo } from '@utils/dates';
import { basicSort } from '@utils/sort';
import { styleDateRange } from '@utils/styles';

export const CutsByResellerLastMonth = () => {
    const { firstDay, lastDay } = getMonthInfo(1);

    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.RESELLER_SUCCESSFUL_CUTS_BY_RESELLER_LAST_MONTH,
        params: { startDate: firstDay, endDate: lastDay, range: 'monthly' },
    });

    return (
        <BaseReport
            title={'Successful Cuts by Resellers Last Month'}
            rangeText={styleDateRange([firstDay, lastDay])}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Reseller Name', 'Company Name', 'Successful Cuts'],
                data: data.map((item) => [item.resellerName, item.companyName, item.successfulCuts]),
                summaries: [count, countUnique, sum],
                sort: [basicSort, basicSort, basicSort],
            }}
        />
    );
};
